// AUTO-GENERATED - Do not manually edit this file
// This file is generated by scripts/devlink/config-generator/generate-props-config.js
import { FIELD_TYPES } from "../../../../../../constants/template-field-type";
export default {
    category1PromptText: {
        type: FIELD_TYPES.TEXT,
        label: "Category 1 Prompt Text",
        translatable: true
    },
    category1Text: {
        type: FIELD_TYPES.TEXT,
        label: "Category 1 Text",
        translatable: true
    },
    category2PromptText: {
        type: FIELD_TYPES.TEXT,
        label: "Category 2 Prompt Text",
        translatable: true
    },
    category2Text: {
        type: FIELD_TYPES.TEXT,
        label: "Category 2 Text",
        translatable: true
    },
    category3PromptText: {
        type: FIELD_TYPES.TEXT,
        label: "Category 3 Prompt Text",
        translatable: true
    },
    category3Text: {
        type: FIELD_TYPES.TEXT,
        label: "Category 3 Text",
        translatable: true
    },
    category4PromptText: {
        type: FIELD_TYPES.TEXT,
        label: "Category 4 Prompt Text",
        translatable: true
    },
    category4Text: {
        type: FIELD_TYPES.TEXT,
        label: "Category 4 Text",
        translatable: true
    },
    category5PromptText: {
        type: FIELD_TYPES.TEXT,
        label: "Category 5 Prompt Text",
        translatable: true
    },
    category5Text: {
        type: FIELD_TYPES.TEXT,
        label: "Category 5 Text",
        translatable: true
    },
    category6PromptText: {
        type: FIELD_TYPES.TEXT,
        label: "Category 6 Prompt Text",
        translatable: true
    },
    category6Text: {
        type: FIELD_TYPES.TEXT,
        label: "Category 6 Text",
        translatable: true
    },
    headingBlack1: {
        type: FIELD_TYPES.TEXT,
        label: "Heading Black 1",
        translatable: true
    },
    headingBlack2: {
        type: FIELD_TYPES.TEXT,
        label: "Heading Black 2",
        translatable: true
    },
    headingGradient: {
        type: FIELD_TYPES.TEXT,
        label: "Heading Gradient",
        translatable: true
    },
    sectionSubtitle: {
        type: FIELD_TYPES.TEXT,
        label: "Section Subtitle",
        translatable: true
    },
    vibePromptBoxText: {
        type: FIELD_TYPES.TEXT,
        label: "Vibe Prompt Box Text",
        translatable: true
    },
    headingBlack1Visibility: {
        type: FIELD_TYPES.BOOLEAN,
        label: "Heading Black 1 Visibility",
        translatable: false
    },
    headingBlack2Visibility: {
        type: FIELD_TYPES.BOOLEAN,
        label: "Heading Black 2 Visibility",
        translatable: false
    },
    hideComponent: {
        type: FIELD_TYPES.BOOLEAN,
        label: "Hide Component",
        translatable: false
    }
};
